module.exports = __webpack_public_path__ + "img/02_uk.b2b8a6db.svg";